<template lang="pug">
  div
    el-dialog(
      title='Selecionar modelo'
      :visible.sync='showModal'
       width='60%'
       v-loading='loading'
    )
      div
        p.padding-titulo Pesquisa de Modelos
        el-input(
          placeholder='Informe a descrição'
          v-model='pesquisa'
          @keypress.native.enter='pesquisarModelos'
        )
          el-button(
            slot='append'
            icon='el-icon-search'
            @click='pesquisarModelos'
          )

      div(v-if="modelos.length === 0")
        p.center Ainda não há modelos disponíveis
      div.container-modelo
        div.item(v-for='item in modelos', :key="item.id")
          div(@click='selectModelo(item.id)')
            el-card.cursor-pointer(:class="{ active: item.id === modeloSelecionado.id }")
              span.descricao {{ item.assunto }}
              p.border-bottom
              p(v-html="verificarTexto(item.conteudo)")
      el-row.button_class(type='flex' justify='space-between')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-times
          span Cancelar
        el-button(
          type='primary'
          @click='usarModelo'
          :disabled='!modeloSelecionado.id'
        )
          i(style='padding-right: 5px;').fa.fa-check
          span Utilizar
</template>
<script>
import { listar, pesquisar } from '@/services/modeloService';

export default {
  props: {
    modalOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  data() {
    return {
      loading: false,
      pesquisa: '',
      modelos: [],
      modeloSelecionado: {},
      modeloUtilizado: {},
    }
  },
  mounted() {
    this.buscarModelos();
  },
  methods: {
    fecharModal() {
      this.$emit('close-modal');
      this.modeloSelecionado = this.modeloUtilizado;
    },

    async buscarModelos() {
      this.loading = true;
      try {
        this.modelos = await listar();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    async pesquisarModelos() {
      if (this.pesquisa === '') {
        this.buscarModelos();
      } else {
        this.loading = true;
        try {
          this.modelos = await pesquisar(this.pesquisa);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      }
    },
    selectModelo (id) {
      if (this.modeloSelecionado.id === id) {
        this.modeloSelecionado = {}
      } else {
        this.modeloSelecionado = this.modelos.find(m => m.id === id)
      }
    },
    usarModelo() {
      this.modeloUtilizado = this.modeloSelecionado;
      this.$emit('usar-modelo', this.modeloSelecionado);
    },
    verificarTexto(texto) {
      if (texto.length > 310) {
        return texto.substring(0, 310) + '...';
      }
      return texto;
    }
  }
}
</script>
<style lang="scss" scoped>
.center {
  text-align: center;
  margin-top: 20px !important;
}
.container-modelo {
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
}
.item {
  margin: 5px;
  width: 340px;
}
.cursor-pointer {
  cursor: pointer;
  height: 300px;
}
.descricao {
  font-weight: bold;
  font-size: 16px;
}
.border-bottom {
  padding-bottom: 10px;
  border-bottom: solid 1px #A7B2BA;
}
.active {
  background: rgb(223, 223, 223) !important;
}
.button_class {
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 10px;
}
</style>
